import {
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  ViewEncapsulation
} from '@angular/core';
import { VgApiService } from '@videogular/ngx-videogular/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-vg-time-display',
  encapsulation: ViewEncapsulation.None,
  template: `
    <span *ngIf="(target?.isLive || isHLS) && !ignoreLive">LIVE</span>
    <span *ngIf="!target?.isLive && !isHLS">{{
      getTime() | vgUtc : vgFormat
    }}</span>
    <span *ngIf="isHLS && ignoreLive">{{ getTime() | vgUtc : vgFormat }}</span>
  `,
  styles: [
    `
      app-vg-time-display {
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        display: flex;
        justify-content: center;
        height: 50px;
        width: 60px;
        cursor: pointer;
        color: white;
        line-height: 50px;
        pointer-events: none;
        font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
      }
    `
  ]
})
export class AppVgTimeDisplayComponent implements OnInit, OnDestroy {
  @Input() vgFor: string;
  @Input() vgProperty = 'current';
  @Input() vgFormat = 'mm:ss';

  /**
   * We want to ignore live in HLS when we want to display current time
   */
  @Input() ignoreLive: boolean = false;
  @Input() isHLS: boolean = false;

  elem: HTMLElement;
  target: any;

  subscriptions: Subscription[] = [];

  constructor(ref: ElementRef, public API: VgApiService) {
    this.elem = ref.nativeElement;
  }

  ngOnInit() {
    if (this.API.isPlayerReady) {
      this.onPlayerReady();
    } else {
      this.subscriptions.push(
        this.API.playerReadyEvent.subscribe(() => this.onPlayerReady())
      );
    }
  }

  onPlayerReady() {
    this.target = this.API.getMediaById(this.vgFor);
  }

  getTime() {
    if (!this.target) {
      return 0;
    }
    const t = Math.round(this.target.time[this.vgProperty]);
    return isNaN(t) ? 0 : t;
  }

  ngOnDestroy() {
    this.subscriptions.forEach((s) => s.unsubscribe());
  }
}
